import { render, staticRenderFns } from "./regular-cycle-myth-englearning.vue?vue&type=template&id=17b95f56&lang=pug"
import script from "./regular-cycle-myth-englearning.vue?vue&type=script&lang=js"
export * from "./regular-cycle-myth-englearning.vue?vue&type=script&lang=js"
import style0 from "./regular-cycle-myth-englearning.vue?vue&type=style&index=0&id=17b95f56&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b95f56')) {
      api.createRecord('17b95f56', component.options)
    } else {
      api.reload('17b95f56', component.options)
    }
    module.hot.accept("./regular-cycle-myth-englearning.vue?vue&type=template&id=17b95f56&lang=pug", function () {
      api.rerender('17b95f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/regular-cycle-myth-englearning.vue"
export default component.exports